var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileItemAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8103 8.182C18.7502 8.12437 18.6786 8.07859 18.5996 8.04734C18.5206 8.0161 18.4358 8 18.3501 8C18.2644 8 18.1796 8.0161 18.1006 8.04734C18.0216 8.07859 17.9499 8.12437 17.8899 8.182L10.1024 15.5234L7.11337 12.6981C6.99106 12.5835 6.82566 12.5192 6.65324 12.5192C6.48081 12.5192 6.31532 12.5835 6.193 12.6981C6.13188 12.7547 6.08336 12.8222 6.05022 12.8967C6.01708 12.9712 6 13.0511 6 13.1319C6 13.2127 6.01708 13.2926 6.05022 13.3671C6.08336 13.4416 6.13188 13.5091 6.193 13.5657L9.64623 16.8211C9.76855 16.9357 9.93394 17 10.1064 17C10.2788 17 10.4443 16.9357 10.5666 16.8211L18.8103 9.04961C18.9318 8.9343 19 8.77833 19 8.61578C19 8.45323 18.9318 8.29731 18.8103 8.182V8.182Z",
    fill: "#7FB722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileItemAccept);
export default __webpack_public_path__ + "static/media/mobileItemAccept.6b329db70ab1b3ff9129b59dcc0ba3e9.svg";
export { ForwardRef as ReactComponent };